import { Component, Inject, OnDestroy, OnInit } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { Subject, takeUntil } from 'rxjs'
import { AyBService } from 'src/app/services/api/ayb.service'
import Swal from 'sweetalert2'
import { FormCocinaService } from '../../../services/forms/form-cocina.service'
@Component({
  selector: 'app-dialog-proveedores',
  templateUrl: './dialog-proveedores.component.html',
  styleUrls: ['./dialog-proveedores.component.scss']
})
export class DialogProveedoresComponent implements OnInit, OnDestroy {
  private _unsubscribeOnDestroy$: Subject<boolean> = new Subject<boolean>()
  providerForm

  constructor (
    private readonly formService: FormCocinaService,
    private readonly alimentosService: AyBService,
    public dialogRef: MatDialogRef<DialogProveedoresComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.providerForm = this.formService.getProveedorForm()
  }

  ngOnInit (): void {
    console.log(this.data)

    this.providerForm
      .get(['cuentaContableDolares'])
      ?.setValue(this.data.cuentaContableDolares)
    this.providerForm
      .get(['cuentaContableSoles'])
      ?.setValue(this.data.cuentaContableSoles)
    this.providerForm
      .get(['direccionSocial'])
      ?.setValue(this.data.direccionSocial)
    this.providerForm.get(['distrito'])?.setValue(this.data.distrito)
    this.providerForm.get(['documento'])?.setValue(this.data.documento)
    this.providerForm
      .get(['nombreComercial'])
      ?.setValue(this.data.nombreComercial)
    this.providerForm.get(['provincia'])?.setValue(this.data.provincia)
    this.providerForm.get(['razonSocial'])?.setValue(this.data?.razonSocial)
    this.providerForm.get(['ruc'])?.setValue(this.data.ruc)
    this.providerForm.get(['telefono'])?.setValue(this.data.telefono)
  }

  ngOnDestroy (): void {
    this._unsubscribeOnDestroy$.next(true)
    this._unsubscribeOnDestroy$.complete()
  }

  createProvider () {
    if (this.providerForm.get(['nombreComercial'])?.value) {
      this.alimentosService
        .mutationCreateProvider(this.providerForm.value)
        .pipe(takeUntil(this._unsubscribeOnDestroy$))
        .subscribe(data => {
          console.log(data)
          this.dialogRef.close(1)
        })
    } else {
      Swal.fire({
        toast: true,
        position: 'top-end',
        title: 'Falta ingresar campos requeridos',
        icon: 'warning',
        showConfirmButton: false,
        timer: 3000
      })
    }
  }

  updateProvider () {
    if (this.providerForm.get(['nombreComercial'])?.value) {
      this.alimentosService
        .mutationUpdateProvider(this.data.id, this.providerForm.value)
        .pipe(takeUntil(this._unsubscribeOnDestroy$))
        .subscribe((data: any) => {
          this.dialogRef.close(1)
        })
    }
  }
}
